<template>
  <div class="wizard-body small-12 medium-9 columns height-auto">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.AUTH.TITLE')"
      :header-content="
        useInstallationName(
          $t('INBOX_MGMT.ADD.AUTH.DESC'),
          globalConfig.installationName
        )
      "
    />
    <div class="row channel-list">
      <channel-item
        v-for="channel in channelList"
        :key="channel.key"
        :channel="channel"
        :enabled-features="enabledFeatures"
        @channel-item-click="initChannelAuth"
      />
    </div>
  </div>
</template>

<script>
import ChannelItem from 'dashboard/components/widgets/ChannelItem';
import router from '../../../index';
import PageHeader from '../SettingsSubPageHeader';
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import { urlThumbnail } from '../../../../helper/commons';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  components: {
    ChannelItem,
    PageHeader,
  },
  mixins: [globalConfigMixin],
  data() {
    return {
      enabledFeatures: {},
    };
  },
  computed: {
    account() {
      return this.$store.getters['accounts/getAccount'](this.accountId);
    },
    channelList() {
      const { apiChannelName, apiChannelThumbnail } = this.globalConfig;
      const channels = [
        {
          key: 'website',
          name: this.$t('INBOX_MGMT.INBOXES.WEBSITE'),
          isVisible: true,
          thumbnail: `${urlThumbnail}/icons/webchat.svg`,
        },
        { key: 'facebook', name: 'Messenger', isVisible: true },
        { key: 'twitter', name: 'Twitter', isVisible: false },
        { key: 'whatsapp', name: 'WhatsApp API', isVisible: true },
        {
          key: 'evolution_api',
          name: 'WhatsApp Business/Personal',
          isVisible: true,
        },
        { key: 'sms', name: 'SMS', isVisible: true },
        {
          key: 'email',
          name: this.$t('INBOX_MGMT.INBOXES.EMAIL'),
          isVisible: true,
        },
        {
          key: 'api',
          name: apiChannelName || 'API',
          thumbnail: apiChannelThumbnail,
          isVisible: true,
        },
        { key: 'telegram', name: 'Telegram', isVisible: false },
        { key: 'line', name: 'Line', isVisible: false },
        { key: 'interteluc', name: 'Intertel UC', isVisible: true },
      ];
      const visibleChannels = channels.filter(channel => channel.isVisible);
      return visibleChannels;
    },
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
    }),
  },
  mounted() {
    this.initializeEnabledFeatures();
  },
  methods: {
    async initializeEnabledFeatures() {
      await this.$store.dispatch('accounts/get', this.accountId);
      this.enabledFeatures = this.account.features;
    },
    initChannelAuth(channel) {
      const params = {
        page: 'new',
        sub_page: channel,
      };
      // Se emite el nombre del tipo de canal selecionado
      bus.$emit(BUS_EVENTS.CREATE_CHANNEL_FLOW, channel);
      const routeName =
        channel !== 'evolution_api'
          ? 'settings_inboxes_page_channel'
          : 'settings_inbox_conditions';
      router.push({ name: routeName, params });
    },
  },
};
</script>
<style scoped>
.height-auto {
  height: auto;
}

.channel-list {
  margin-top: var(--space-medium);
}
</style>
